import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const InsuranceSecondaryIcon = (props) => (
  <SvgIcon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.812 4.28399L12.812 1.17299C12.295 0.942988 11.705 0.942988 11.188 1.17299L4.188 4.28399C3.465 4.60399 3 5.31999 3 6.11199V11C3 18.83 9.439 22.486 12 23C14.561 22.486 21 18.83 21 11V6.11199C21 5.32099 20.535 4.60399 19.812 4.28399ZM12 12.9999C11.448 12.9999 11 12.5519 11 11.9999V7.9999C11 7.4479 11.448 6.9999 12 6.9999C12.552 6.9999 13 7.4479 13 7.9999V11.9999C13 12.5519 12.552 12.9999 12 12.9999ZM12.5 16.9999H11.5C11.224 16.9999 11 16.7759 11 16.4999V15.4999C11 15.2239 11.224 14.9999 11.5 14.9999H12.5C12.776 14.9999 13 15.2239 13 15.4999V16.4999C13 16.7759 12.776 16.9999 12.5 16.9999Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

InsuranceSecondaryIcon.propTypes = {
  sx: PropTypes.object,
};

export default InsuranceSecondaryIcon;
